import { useEffect, useRef } from 'react';
import { useFragment, graphql } from 'react-relay';
import { addLocalRecentHistoryItem } from 'dibs-recent-history/exports/addLocalRecentHistoryItem.ts';

import { type usePdpRecentHistoryTracker_item$key } from './__generated__/usePdpRecentHistoryTracker_item.graphql.ts';

const itemFragment = graphql`
    fragment usePdpRecentHistoryTracker_item on Item {
        ...addLocalRecentHistory_item @relay(mask: false)
    }
`;

export const usePdpRecentHistoryTracker = ({
    item: itemRef,
    skipTracking = false,
}: {
    item?: usePdpRecentHistoryTracker_item$key | null;
    skipTracking?: boolean;
} = {}): void => {
    const item = useFragment(itemFragment, itemRef);
    const isTracked = useRef(false);

    useEffect(() => {
        if (!isTracked.current && item && !skipTracking) {
            addLocalRecentHistoryItem(item as $TSFixMe);
            isTracked.current = true;
        }
    }, [item, skipTracking]);
};
